import { useLocation } from 'react-router-dom';
import { useCandidateNav } from '../contexts/CandidateNavContext';

const ALLOWED_ROUTES = ['/analytics', '/settings', '/build-resume'] as const;

const ALLOWED_CANDIDATE_TABS = ['overview', 'skills', 'activity'] as const;

export const useFloatingAssistVisibility = (): boolean => {
  const { pathname } = useLocation();
  const activeNav = useCandidateNav();

  if ((ALLOWED_ROUTES as readonly string[]).includes(pathname)) {
    return true;
  }

  if (
    pathname === '/candidate' &&
    activeNav &&
    (ALLOWED_CANDIDATE_TABS as readonly string[]).includes(activeNav)
  ) {
    return true;
  }

  return false;
};
